import CuepointDotContainer from "containers/cuepoint/CuepointDotContainer";
import PropTypes from "prop-types";
import React from "react";

import map from "lodash/map";
import range from "lodash/range";

export default class CuepointDots extends React.PureComponent {
  static propTypes = {
    chapterId: PropTypes.number.isRequired, //required for analytics
    numberOfCuepoints: PropTypes.number.isRequired,
    showCuepoints: PropTypes.bool,
  };

  render() {
    const cuepoints = map(range(0, this.props.numberOfCuepoints), (index) => (
      <CuepointDotContainer
        chapterId={this.props.chapterId}
        cuepointIndex={index}
        key={`${index}of${this.props.numberOfCuepoints}`}
      />
    ));

    return (
      <div className="cuepoints-wrap">
        <div className="cuepoints">
          {this.props.showCuepoints ? cuepoints : null}
        </div>
      </div>
    );
  }
}
